import useAutoResizeToParent from './useAutoResizeToParent'
import ResellerSearch from './ResellerSearch'

/**
 * Auto-resizing account-wide search embed. Renders the search widget unchanged
 * and posts its height so the host iframe resizes to fit its content (it grows
 * and shrinks as the customer searches). Safe for existing fixed-height embeds.
 */
export default function AutoResizeSearch() {
  useAutoResizeToParent()
  return <ResellerSearch />
}
